import type { Testimonial } from '../types/content'

export const testimonials: Testimonial[] = [
  {
    initials: 'SR',
    quote:
      'Ho sempre saputo che qualcosa non andava ma non potevo chiamarlo. Le carte di costellazione hanno reso tutto visibile per la prima volta. Ho pianto durante metà del Tomo II — e erano le migliori lacrime della mia vita.',
    name: 'Sofia R.',
    role: 'Roma, Italia · Auto-guaritrice',
  },
  {
    initials: 'JM',
    quote:
      'Il Bonus Genogramma di Soluzione da solo ha completamente cambiato il mio sguardo sul denaro. Non avevo mai messo in relazione i miei blocchi finanziari con il fallimento di mio nonno. Questo sistema mi ha dato il linguaggio per riconoscere quello schema.',
    name: 'Giovanni M.',
    role: 'Milano, Italia · Coach & Praticante',
  },
  {
    initials: 'MD',
    quote:
      'Le risorse stampabili sono incomparabili. Ho le carte di costellazione sul muro del mio studio. I miei clienti mi fanno domande su di loro ad ogni sessione. Vale ogni centesimo e dieci volte di più.',
    name: 'Maria D.',
    role: 'Torino, Italia · Terapeuta Olistica',
  },
]

export const reviews: Testimonial[] = [
  {
    initials: 'MF',
    quote:
      'Ho aperto il Tomo IV un martedì sera e giovedì qualcosa si era mosso in me che portavo da 20 anni. I modelli di liberazione lo hanno reso possibile. Finalmente mi sento me stesso.',
    name: 'Michele F.',
    role: 'Genova, Italia · Ricercatore Spirituale',
  },
  {
    initials: 'NG',
    quote:
      'Il Bonus Genogramma di Soluzione ha cambiato tutto. Cartografare tre generazioni su una sola pagina è stata la cosa più illuminante che abbia mai fatto. Schemi che ho vissuto per 40 anni improvvisamente avevano un senso completo.',
    name: 'Nicoletta G.',
    role: 'Palermo, Italia · Studentessa di Psicologia',
  },
  {
    initials: 'AL',
    quote:
      'Ho usato la guida con mio partner. Abbiamo cartografato entrambi i nostri sistemi familiari. Per la prima volta abbiamo smesso di combattere l’uno contro l’altro e abbiamo iniziato ad ascoltarci. Per noi è stato uno strumento di comprensione preziosissimo.',
    name: 'Alessia L.',
    role: 'Firenze, Italia · Coach Olistica',
  },
]
